import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div<{ $active: boolean }>`
	display: flex;
	align-items: center;
	column-gap: 20px;
	height: 50px;
	padding: 0 20px;
	cursor: pointer;
	border-radius: 10px;
	background-color: ${(props) => (props.$active ? '#EF3124' : 'transparent')};
	transition: background-color 0.3s ease;

	${Text} {
		font-size: 16px;
		color: #ffffff;
		opacity: ${(props) => (props.$active ? 1 : 0.5)};
		transition:
			opacity 0.3s ease,
			color 0.3s ease;
	}

	img {
		pointer-events: none;
		opacity: ${(props) => (props.$active ? 1 : 0.5)};
		transition:
			opacity 0.3s ease,
			filter 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			opacity: 1;
			filter: invert(1);
		}

		${Text} {
			opacity: 1;
			color: #000000;
		}
	}
`;

export { StyledContainer };
